import { PopupLocationMarker } from '@/components/PopupLocationMarker'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { getPlacesPhotoUrl } from '@/utils'
import { type FC } from 'react'

import { BusinessContact, BusinessRating } from '..'

interface BusinessLocationMarkerProps {
	latitude: number
	longitude: number
	location: google.maps.places.PlaceResult
}

export const BusinessLocationMarker: FC<BusinessLocationMarkerProps> = ({
	latitude,
	longitude,
	location,
}) => {
	const imageUrl = getPlacesPhotoUrl((location.photos?.[0] as any)?.photo_reference)

	return (
		<PopupLocationMarker coordinates={{ latitude, longitude }}>
			<Card className="w-[300px] pt-0 overflow-hidden">
				{imageUrl && (
					<div
						className="h-[140px] w-full bg-cover bg-center"
						style={{ backgroundImage: `url(${imageUrl})` }}
						role="img"
						aria-label={location.name}
					/>
				)}
				<CardHeader>
					<h3 className="text-lg font-semibold leading-none tracking-tight">{location.name}</h3>
					<BusinessRating
						size="small"
						rating={location.rating}
						totalRatings={location.user_ratings_total}
					/>
				</CardHeader>
				<CardContent>
					<BusinessContact
						phone={location.formatted_phone_number}
						address={location.formatted_address}
					/>
					{location.opening_hours && (
						<p className="text-sm text-muted-foreground">
							{(location.opening_hours as any).open_now ? 'Open' : 'Closed'}
						</p>
					)}
				</CardContent>
			</Card>
		</PopupLocationMarker>
	)
}
